<template>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <div v-if="aviso == 'S'" class="card">
          <div class="card-header bg-primary text-white">
            <b>Atenção!!!!!</b>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                REPASSE DE COMISSÃO BLOQUEADA. FAVOR ENTRAR EM CONTATO COM O
                C.D.
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header bg-primary text-white">
            <b>Comissões</b>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <input
                  type="checkbox"
                  @change="setDevolucao"
                  value="false"
                  id="devolucao"
                />
                <label class="form-check-label"> Filtrar por devoluções</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-4">
                <input
                  type="checkbox"
                  @change="setTipoTitulo"
                  value="false"
                  id="tipo-titulo"
                />
                <label class="form-check-label">
                  Filtrar por boletos emitidos para o distribuidor (boletos não
                  pagos pela revendedora e não devolvidos)</label
                >
              </div>
            </div>
            <div class="row">
              <div class="col mt-4">
                <input
                  type="checkbox"
                  @change="setDtPagamento"
                  value="false"
                  id="data-pagamento"
                />
                <label class="form-check-label">
                  Filtrar por data de pagamento da comissão</label
                >
              </div>
            </div>
            <div class="form-group row mt-4">
              <label class="col-sm-2 col-form-label">Data de emissão</label>
              <input type="hidden" name="comissoes" value="1" />
              <div class="col-sm-2">
                <select
                  v-model="data_emissao"
                  class="form-control"
                  required
                  id="data_emissao"
                  :disabled="filtraPagamento"
                >
                  <option
                    v-for="(item, i) in emissoes"
                    :key="i"
                    :value="item.dtemissao_titulo"
                  >
                    {{ formatData(item.dtemissao_titulo) }}
                  </option>
                </select>
              </div>
              <div class="col-sm-6">
                <button
                  class="btn btn-primary"
                  type="submit"
                  @click="getComissoes"
                  :disabled="filtraPagamento"
                >
                  Buscar
                </button>
                <button class="btn btn-secondary" type="button" @click="Limpar">
                  Limpar
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <span class="badge badge-warning"
                  >Obs.: As comissões serão repassadas para as contas bancárias
                  nos dias 05 e 20 de cada mês</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="card" v-if="linhas.length > 0">
          <div class="card-header bg-primary text-white">Resumo</div>
          <div class="panel-body">
            <div class="table">
              <table
                class="table-hover table-striped table-bordered table-sm"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>Situação</th>
                    <th>Total</th>
                    <th>Valor total</th>
                    <th>Comissão</th>
                    <th>Percentual</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in showResumo" :key="i">
                    <td>{{ item.situacao }}</td>
                    <td>{{ item.total ? item.total : 0.0 }}</td>
                    <td>
                      {{
                        item.valor_total
                          ? item.valor_total.toString().replace(".", ",")
                          : 0.0
                      }}
                    </td>
                    <td>
                      {{
                        item.total_comissao
                          ? item.total_comissao.toString().replace(".", ",")
                          : 0.0
                      }}
                    </td>
                    <td>{{ item.percentual ? item.percentual : 0 }} %</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card" v-if="detalhes.length > 0">
          <div class="card-header bg-primary text-white">
            Detalhes <b>{{ filtraPagamento ? " de comições PAGAS " : "" }}</b>
            <br />
            <small>Você filtrou por apenas comissões pagas...</small>
          </div>
          <div class="card-body">
            <table
              class="table-hover table-striped table-bordered table-sm"
              width="100%"
            >
              <tr>
                <td>
                  <input v-model="revendedora" class="form-control" />
                </td>
                <td><input v-model="pdv_nome" class="form-control" /></td>
                <td>
                  <select v-model="filtraEmissao" class="form-control">
                    <option value="">Sem filtro</option>
                    <option
                      v-for="(item, i) in getDataEmissao"
                      :value="formatData(item)"
                      :key="i"
                    >
                      {{ formatData(item) }}
                    </option>
                  </select>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <b>R$ {{ swowTotalTitulo }}</b>
                </td>
                <td>
                  <b>R$ {{ swowTotalcomissao }}</b>
                </td>
                <td>
                  <select v-model="filtraPgto" class="form-control">
                    <option value="">Sem filtro</option>
                    <option
                      v-for="(item, i) in getDataPgto"
                      :value="formatData(item)"
                      :key="i"
                    >
                      {{ formatData(item) }}
                    </option>
                  </select>
                </td>
                <td>
                  <select v-model="situacao" class="form-control">
                    <option value="">Sem Filtro</option>
                    <option>Comissão Paga</option>
                    <option>Devolvido</option>
                    <option>Pago</option>
                    <option>Aberto</option>
                    <option>Em Devolução</option>
                    <option>Descontado do Distrib.</option>
                  </select>
                </td>
              </tr>
              <thead>
                <tr>
                  <th>Revendedora</th>
                  <th>Ponto de apoio</th>
                  <th>Data Emissão</th>
                  <th>Data de Vencimento</th>
                  <th>Data Pagamento</th>
                  <th>Título</th>
                  <th width="10%">Valor</th>
                  <th>Comissao</th>
                  <th>Data Transf. Comissão</th>
                  <th>Situação</th>
                  <th width="10%">Historico</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in showDetalhes" :key="i">
                  <td>{{ item.nome_revendedora }}</td>
                  <td>{{ item.pdv_nome }}</td>
                  <td class="text-center">{{ item.data_emissao }}</td>
                  <td class="text-center">{{ item.data_vencimento }}</td>
                  <td class="text-center">{{ item.data_pagamento }}</td>
                  <td class="text-center">
                    <a
                      :href="'/boleto/generate/' + item.boleto_id"
                      target="_blank"
                    >
                      {{ item.titulo }}
                    </a>
                  </td>
                  <td class="text-center">R$ {{ item.valor_titulo }}</td>
                  <td class="text-center">{{ item.comissao }}</td>
                  <td class="text-center">{{ item.pagamento }}</td>
                  <td class="text-center">{{ item.status }}</td>
                  <td class="text-center">
                    <span v-if="item.historico == '-'"> - </span>
                    <span v-else
                      ><a href="javascript:" @click="showHist(item)"
                        >Ver detalhes</a
                      ></span
                    >
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <b>R$ {{ swowTotalTitulo }}</b>
                  </td>
                  <td>
                    <b>R$ {{ swowTotalcomissao }}</b>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div id="my-modal" class="modal fade">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Histórico</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p v-html="hist"></p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabelaComissoes",
  data() {
    return {
      filtraPagamento: false,
      filtraTitulo: false,
      colunas: [
        ["situacao", "Situação"],
        ["total", "Total"],
        ["valor_total", "Valor Total"],
        ["total_comissao", "Comissão"],
        ["percentual", "Percentual"],
      ],
      colunasDet: [
        ["nome_revendedora", "Nome Revendedora"],
        ["pdv_nome", "Ponto de apoio"],
        ["titulo", "Título"],
        ["valor_titulo", "Valor Título"],
        ["comissao", "Comissão"],
        ["status", "Situação"],
        ["dt_pgto_comissao", "Data Pgto"],
      ],
      linhas: [],
      total_comissoes: 0,
      total: 0,
      detalhes: [],
      distribuidor: $("#distribuidor").val(),
      data_emissao: "",
      data_vencimento: "",
      data_pagamento: "",
      emissoes: [],
      aviso: "",
      revendedora: "",
      pdv_nome: "",
      titulo: "",
      situacao: "",
      filtraEmissao: "",
      filtraPgto: "",
      showModal: false,
      hist: "",
      tipo_titulo: "",
    };
  },
  methods: {
    setDtPagamento(event) {
      if (typeof event === "undefined") {
        return;
      }
      console.log(event);
      this.filtraPagamento = event.target.checked;
      if (this.filtraPagamento) {
        this.data_emissao = "";
        this.tipo_titulo = "";
        this.getComissoes();
      } else {
        this.Limpar();
      }
    },
    setTipoTitulo(event) {
      if (typeof event === "undefined") {
        return;
      }
      console.log(event);
      this.filtraPagamento = event.target.checked;
      if (this.filtraPagamento) {
        this.tipo_titulo = "FAT";
        this.data_emissao = "";
        this.getComissoes();
      } else {
        this.Limpar();
      }
    },
    setDevolucao(event) {
      if (typeof event === "undefined") {
        return;
      }
      console.log(event);
      this.filtraPagamento = event.target.checked;
      if (this.filtraPagamento) {
        this.tipo_titulo = "DEV";
        this.data_emissao = "";
        this.getComissoes();
      } else {
        this.Limpar();
      }
    },
    Limpar() {
      this.situacao = "";
      this.filtraPagamento = false;
      var inputs = $("input[type=checkbox]");
      inputs.attr("checked", false);
      inputs.prop("checked", false);
      this.titulo = "";
      this.revendedora = "";
      this.linhas = [];
      this.detalhes = [];
      this.data_emissao = "";
    },
    formatData(data) {
      if (typeof data === "undefined") {
        return "";
      }
      return moment(data).format("DD/MM/YYYY");
    },
    setStatus(value) {
      if (value === "A") {
        return "Aberto";
      } else if (value === "B") {
        return "Pago";
      } else if (value === "S") {
        return "Em Devolução";
      } else if (value === "R") {
        return "Devolvido";
      } else if (value === "C") {
        return "Comissão Paga";
      } else if (value === "D") {
        return "Descontado do Distrib.";
      } else {
        return "Não identificado";
      }
    },
    getOnload() {
      var vm = this;
      $(".loading").show();
      axios
        .get("/distribuidor/comissoes", { params: { data_emissao: "all" } })
        .then(function (response) {
          vm.emissoes = response.data[0];
          vm.aviso = response.data[1];
          $(".loading").hide();
        })
        .catch((error) => {
          $(".loading").hide();
          console.log(error);
        });
    },
    getComissoes() {
      var vm = this;
      if (this.data_emissao === "" && !this.filtraPagamento) {
        return this.$swal(
          "Informe a data de emissão",
          "para gerar o relatório é necessário selecionar uma data.",
          "error"
        );
      }
      $(".loading").show();
      axios
        .get("/distribuidor/comissoes", {
          params: {
            distribuidor: vm.distribuidor,
            data_emissao: vm.data_emissao,
            data_pagamento: vm.filtraPagamento,
            tipo_titulo: vm.tipo_titulo,
          },
        })
        .then(function (resp) {
          if (resp.data.comissoes) {
            vm.linhas = resp.data.comissoes;
          }
          vm.detalhes = resp.data.detalhes;
          $(".loading").hide();
        })
        .catch((error) => {
          console.log(error);
          $(".loading").hide();
          vm.$swal(
            "Houve um erro ao gerar relatório",
            "tente novamente mais tarde",
            "error"
          );
        });
    },
    showHist(item) {
      this.hist = item.historico;
      $("#my-modal").modal("show");
    },
  },
  computed: {
    getDataEmissao() {
      var datas = [];
      this.detalhes.map((el) => {
        if (datas.indexOf(el.dtemissao_titulo) < 0) {
          datas.push(el.dtemissao_titulo);
        }
      });
      return datas.sort();
    },
    getDataPgto() {
      var datas = [];
      this.detalhes.map((el) => {
        if (datas.indexOf(el.dt_pgto_comissao) < 0) {
          datas.push(el.dt_pgto_comissao);
        }
      });
      return datas.sort();
    },
    swowTotalTitulo() {
      var total = 0;
      this.showDetalhes.forEach((a) => {
        total += parseFloat(a.valor_titulo.replace(",", "."));
      });
      return total.toFixed(2).toString().replace(".", ",");
    },
    swowTotalcomissao() {
      var total = 0;
      this.showDetalhes.forEach((a) => {
        total += parseFloat(a.comissao.replace(",", "."));
      });
      return total.toFixed(2).toString().replace(".", ",");
    },
    showDetalhes() {
      var arrayData = [];
      var vm = this;
      this.detalhes.forEach(function (a) {
        arrayData.push({
          nome_revendedora: a.nome_revendedora,
          pdv_nome: a.pdv_nome != null ? a.pdv_nome : " ",
          data_emissao: a.dtemissao_titulo
            ? moment(a.dtemissao_titulo).format("DD/MM/YYYY")
            : "-",
          data_vencimento: a.vencimento
            ? moment(a.vencimento).format("DD/MM/YYYY")
            : "-",
          data_pagamento: a.data_pagamento
            ? moment(a.data_pagamento).format("DD/MM/YYYY")
            : "-",
          titulo: a.titulo,
          valor_titulo: a.valor_titulo.toString().replace(".", ","),
          comissao: a.comissao.toString().replace(".", ","),
          pagamento: a.dt_pgto_comissao
            ? moment(a.dt_pgto_comissao).format("DD/MM/YYYY")
            : "-",
          status: vm.setStatus(a.status),
          historico: a.historico
            ? a.historico.replaceAll("@@@", "<br />")
            : "-",
          boleto_id: a.boleto_id ? a.boleto_id : "",
        });
      });

      if (this.revendedora.length > 3) {
        arrayData = arrayData.filter((el) => {
          return (
            el.nome_revendedora
              .toUpperCase()
              .indexOf(vm.revendedora.toUpperCase()) > -1
          );
        });
      }
      if (this.pdv_nome.length > 3) {
        arrayData = arrayData.filter((el) => {
          return (
            el.pdv_nome.toUpperCase().indexOf(vm.pdv_nome.toUpperCase()) > -1
          );
        });
      }
      if (this.situacao) {
        arrayData = arrayData.filter((el) => {
          return el.status.indexOf(vm.situacao) > -1;
        });
      }

      if (this.filtraEmissao) {
        // console.log(this.filtraEmissao)
        arrayData = arrayData.filter((el) => {
          return el.data_emissao.indexOf(vm.filtraEmissao) > -1;
        });
      }
      if (this.filtraPgto) {
        arrayData = arrayData.filter((el) => {
          return el.pagamento.indexOf(vm.filtraPgto) > -1;
        });
      }

      return arrayData;
    },
    showResumo() {
      var arrayData = [];
      var total = 0;
      for (var b = 0; this.linhas.length > b; b++) {
        if (b === 0) {
          total = this.linhas[b].total;
        }
        arrayData.push({
          situacao: this.linhas[b].situacao,
          total: this.linhas[b].total,
          valor_total: this.linhas[b].valor_total,
          total_comissao: this.linhas[b].total_comissao,
          percentual:
            total > 0
              ? parseFloat((this.linhas[b].total / total) * 100).toFixed(2)
              : 0,
        });
      }

      return arrayData;
    },
  },
  mounted() {
    this.getOnload();
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px 0;
  height: 400px;
  overflow: auto;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/relatorio/TabelaComissoes.vue